import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material'
import { useDataApi } from '../../context/DataApiContext'

// Menu to pick the PV d'admission template of a vehicle type. When
// `defaultToAcquisition` is set and there is no value, the "Acquisition"
// template (legacyType === 'acquisition') is selected once the list loads.
export default function PvAdmissionTemplateSelect({
  value,
  onChange,
  defaultToAcquisition = false,
}) {
  const { t } = useTranslation()
  const { dataProvider } = useDataApi()
  const [templates, setTemplates] = useState([])
  const [loadError, setLoadError] = useState(false)

  useEffect(() => {
    let active = true
    dataProvider.pvAdmissionTemplates
      .getAll()
      .then((items) => {
        if (active) {
          setTemplates(items)
          setLoadError(false)
        }
      })
      .catch(() => {
        if (active) {
          setTemplates([])
          setLoadError(true)
        }
      })
    return () => {
      active = false
    }
  }, [dataProvider])

  useEffect(() => {
    if (!defaultToAcquisition || value != null) {
      return
    }
    const acquisition = templates.find(
      (template) =>
        template.legacyType === 'acquisition' && template.hasDocument
    )
    if (acquisition) {
      onChange(acquisition.id)
    }
  }, [defaultToAcquisition, templates, value, onChange])

  const hasValue = templates.some((template) => template.id === value)

  return (
    <FormControl fullWidth variant="standard" error={loadError}>
      <InputLabel id="pvAdmissionTemplate-label">
        {t('create-vehicle-type-dialog.pv-admission-template')}
      </InputLabel>
      <Select
        labelId="pvAdmissionTemplate-label"
        id="pvAdmissionTemplate"
        value={hasValue ? value : ''}
        onChange={(event) => onChange(event.target.value)}
      >
        {templates.map((template) => (
          <MenuItem
            key={template.id}
            value={template.id}
            disabled={!template.hasDocument}
          >
            {template.hasDocument
              ? template.name
              : t(
                  'create-vehicle-type-dialog.pv-admission-template-no-document',
                  {
                    name: template.name,
                  }
                )}
          </MenuItem>
        ))}
      </Select>
      {loadError && (
        <FormHelperText>
          {t('create-vehicle-type-dialog.pv-admission-template-load-error')}
        </FormHelperText>
      )}
    </FormControl>
  )
}
